"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftFooter = void 0;
const ac_1 = require("@app/ac");
const transfer_1 = require("@app/ac/shift-1.5/transfer");
const ui_1 = require("@app/component/ui");
const button_with_opts_1 = require("@app/component/ui/button-with-opts/button-with-opts");
const reply_action_1 = __importDefault(require("@app/request/reply-action"));
const shifts_publish_1 = require("@app/request/shifts-publish");
const store_1 = __importStar(require("@app/store"));
const util_1 = require("@app/util");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const error_handler_1 = require("@app/util/error-handler");
const use_modal_1 = require("@app/util/modal/use-modal");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const shift_1 = require("../shift");
const shift_context_1 = require("../shift-context");
const use_save_shift_middleware_1 = require("../util/middleware/use-save-shift-middleware");
const ShiftFooter = () => {
    const workspaceId = (0, store_1.useRootSelector)((state) => state.workspaceId);
    const { loading, handleSubmit, formControl, disabledEditation, onSubmit, templateName, formType, initialData, copiesCount, dummyShift, saving, targetWsId, transferStatus, transferType, transferRole, transferActionId, getValues, errors, } = (0, shift_context_1.useShift)();
    const { closeModal, openModal } = (0, use_modal_1.useModal)();
    const dispatch = (0, store_1.useRootDispatch)();
    const hasErrors = (0, util_1.isDefined)(errors) && errors.length > 0;
    const onInvalidHandle = () => { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const _save = (action) => handleSubmit(async (dataIn) => {
        const data = { ...dataIn };
        const hasAction = (0, util_1.isDefined)(action);
        if (!data.pausesFixed) {
            // @ts-expect-error
            data.pauses = dummyShift?.pauses?.filter(util_1.isValue) || data.pauses || [];
        }
        if ((0, use_save_shift_middleware_1.isSaveLiveFunction)(formType, onSubmit)) {
            if (transferStatus === 'create' && targetWsId) {
                await (0, transfer_1.createTransfer)({
                    form: data,
                    targetWsId,
                    shiftId: initialData?.shiftId,
                    type: transferType,
                    beforeCreate: initialData?.shiftId
                        ? async () => {
                            await onSubmit({
                                data,
                                updateVariant: 'default',
                                extra: {
                                    runAfterSubmit: !hasAction,
                                },
                            });
                        }
                        : undefined,
                });
                closeModal();
                if (initialData?.afterSubmit) {
                    void initialData.afterSubmit(undefined);
                }
                return;
            }
            let updateVariant = 'default';
            if (transferRole === 'slave') {
                updateVariant = 'transferSlave';
            }
            if (transferRole === 'master') {
                updateVariant = 'transferMaster';
            }
            const _shift = await onSubmit({
                data,
                updateVariant,
                extra: {
                    runAfterSubmit: !hasAction,
                    copiesCount,
                },
            });
            closeModal();
            if (action === 'shift_add_and_publish') {
                if ((0, util_1.isValue)(workspaceId)) {
                    await (0, shifts_publish_1.mutateShiftsPublish)({
                        workspace: workspaceId,
                        ids: [_shift?.id].filter(util_1.isValue),
                    });
                    await dispatch((0, ac_1.setCalendar)(store_1.default.getState().calendar));
                }
            }
            if (action === 'shift_add_and_save_template' ||
                action === 'attendance_add_and_save_template' ||
                action === 'attendance_edit_and_save_template') {
                if (!(0, util_1.isValue)(_shift))
                    return;
                const { id, employeeId, user, userId, period, contractId, contractType, ...shiftData } = _shift;
                openModal(shift_1.ShiftModal, {
                    initialData: {
                        type: 'shiftTemplate',
                        data: shiftData,
                        afterSubmit: async () => {
                            closeModal();
                        },
                    },
                });
            }
            return;
        }
        if ((0, use_save_shift_middleware_1.isSaveShiftTemplateFunction)(formType, onSubmit)) {
            if (templateName.length === 0)
                return;
            await onSubmit({
                data,
                extra: {
                    shiftTemplateName: templateName,
                    shiftTemplateId: initialData?.shiftTemplateId,
                },
            });
        }
        if ((0, use_save_shift_middleware_1.isSaveTemplateFunction)(formType, onSubmit)) {
            await onSubmit({ data, extra: { copiesCount } });
        }
        if ((0, use_save_shift_middleware_1.isSaveCycleFunction)(formType, onSubmit)) {
            await onSubmit({
                data,
            });
        }
        closeModal();
    }, onInvalidHandle);
    const period = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'period.start' });
    // Same rule as the modal title in shift-header.tsx: a started shift is attendance.
    const IS_ATTENDANCE = period.isBefore((0, moment_1.default)());
    const shiftId = initialData?.shiftId;
    const SHOULD_SAVE = (0, util_1.isDefined)(initialData?.shiftId) || (0, util_1.isDefined)(initialData?.shiftTemplateId);
    const IS_SHIFT = formType === 'live';
    const SHIFT_OPTIONS_ADD = [
        {
            label: (0, util_1.t)('ADD_AND_PUBLISH'),
            value: 'shift_add_and_publish',
        },
        {
            label: (0, util_1.t)('ADD_AND_SAVE_TEMPLATE'),
            value: 'shift_add_and_save_template',
        },
    ];
    const ATTENDANCE_OPTIONS_ADD = [
        {
            label: (0, util_1.t)('ADD_AND_SAVE_TEMPLATE'),
            value: 'attendance_add_and_save_template',
        },
    ];
    const ATTENDANCE_OPTIONS_EDIT = [
        {
            label: (0, util_1.t)('EDIT_AND_SAVE_TEMPLATE'),
            value: 'attendance_edit_and_save_template',
        },
    ];
    const OPTIONS = react_1.default.useMemo(() => IS_SHIFT
        ? IS_ATTENDANCE
            ? SHOULD_SAVE
                ? ATTENDANCE_OPTIONS_EDIT
                : ATTENDANCE_OPTIONS_ADD
            : SHOULD_SAVE
                ? ATTENDANCE_OPTIONS_EDIT
                : SHIFT_OPTIONS_ADD
        : undefined, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [IS_ATTENDANCE]);
    const SAVE_BUTTON_TEXT = IS_SHIFT
        ? IS_ATTENDANCE
            ? SHOULD_SAVE
                ? (0, util_1.t)('EDIT')
                : (0, util_1.t)('ADD')
            : SHOULD_SAVE
                ? (0, util_1.t)('EDIT')
                : (0, util_1.t)('ADD')
        : SHOULD_SAVE
            ? (0, util_1.t)('SAVE')
            : (0, util_1.t)('ADD');
    // {loading && <Icon size='small' color='primary' ico='loader' />}
    const saveTimeoutId = react_1.default.useRef();
    const saveCallback = react_1.default.useCallback((action) => {
        if (!(0, util_1.isDefined)(saveTimeoutId.current)) {
            saveTimeoutId.current = setTimeout(async () => {
                await _save(action)();
            }, 500);
        }
    }, [saveTimeoutId, _save]);
    react_1.default.useEffect(() => {
        const handleGlobalKeyPress = (event) => {
            if (event.key === 'Enter' && !loading) {
                saveCallback();
            }
        };
        document.addEventListener('keydown', handleGlobalKeyPress);
        return () => {
            document.removeEventListener('keydown', handleGlobalKeyPress);
        };
    }, [_save, loading, saveCallback]);
    const [transferActionInProgress, setTransferActionInProgress] = react_1.default.useState(false);
    async function transferReplyHandler(reply) {
        setTransferActionInProgress(true);
        try {
            await (0, reply_action_1.default)({
                actions: [transferActionId],
                reply,
            });
            setTransferActionInProgress(false);
            closeModal();
        }
        catch (error) {
            setTransferActionInProgress(false);
            (0, error_handler_1.processErrors)([], (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('ERR_MESSAGE.error')));
        }
    }
    return (react_1.default.createElement("div", { style: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        } },
        (0, util_1.isDefined)(shiftId) && (react_1.default.createElement("div", { style: { width: '100%' } },
            react_1.default.createElement(ui_1.Text, { type: ui_1.Text.TYPES.BODY_SMALL },
                "DS ID:",
                react_1.default.createElement("span", { style: { cursor: 'pointer' }, onClick: () => util_1.miscUtil.copyToClipBoard(shiftId) }, shiftId)))),
        react_1.default.createElement("div", { style: {
                width: '100%',
                height: '100%',
                display: 'flex',
                gap: '0.5rem',
                justifyContent: 'end',
            } },
            react_1.default.createElement(ui_1.Button, { size: transferStatus === 'pending' && transferRole === 'master'
                    ? 'LARGE'
                    : 'MEDIUM', onClick: () => {
                    if (transferStatus === 'pending' && transferRole === 'master') {
                        void transferReplyHandler('no');
                    }
                    else {
                        closeModal();
                        util_1.multiSelectUtil.multiSelectClear();
                    }
                } }, transferStatus === 'pending' && transferRole === 'master'
                ? (0, util_1.t)('REJECT')
                : (0, util_1.t)('CLOSE')),
            transferStatus === 'pending' ? (react_1.default.createElement(ui_1.Button, { style: 'CONTAINED', size: 'LARGE', loading: loading || saving || transferActionInProgress, onClick: () => {
                    void transferReplyHandler(transferRole === 'slave' ? 'cancel' : 'yes');
                } }, (0, util_1.t)(transferRole === 'slave' ? 'CANCEL' : 'ACCEPT'))) : (react_1.default.createElement(button_with_opts_1.ButtonWithOpts, { testid: shiftId ? 'save-shift-button' : 'add-shift-button', onChange: (v) => {
                    saveCallback(v.value);
                }, style: 'CONTAINED', options: transferStatus === 'none' ? OPTIONS : undefined, onClick: () => {
                    saveCallback();
                }, loading: loading || saving || (0, util_1.isDefined)(saveTimeoutId.current), disabled: hasErrors ||
                    (disabledEditation
                        ? disabledEditation !== 'disabled-due-to-transfer'
                        : transferStatus === 'create' &&
                            (!getValues().position || !getValues().user || !targetWsId)) }, SAVE_BUTTON_TEXT)))));
};
exports.ShiftFooter = ShiftFooter;
